import { ActionIcon, Flex, Image } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import Logo from "../Logo";
import { client_selected } from "../../client";

const SocialsFooter = () => {
  const isLargerThan1120 = useMediaQuery("(min-width: 1120px)");
  const socialLinks = client_selected.socialLinks;

  return (
    <Flex
      direction="column"
      gap={{ base: 32, 550: 40 }}
      mih={118}
      h="100%"
      w="100%"
      align={{ base: "start", 450: "center", 796: "end" }}
      maw={{ base: 310, 450: 480, 796: 180, 1120: 310 }}
    >
      <Flex justify={{ base: "start", 670: "end" }}>
        <Logo height={isLargerThan1120 ? 45 : 53} />
      </Flex>
      <Flex justify="space-between" align="center" w="100%">
        {socialLinks.map((item, index) => (
          <ActionIcon
            key={index}
            component="a"
            target="_blank"
            href={item.path}
            id={item.name}
            variant="transparent"
            sx={{
              height: "fit-content",
              width: "fit-content",
              transition: "0.3s",
              borderRadius: "0 !important",
              padding: "0",
              border: "unset",
              svg: {
                ":hover": {
                  filter: "drop-shadow(0px 0px 2px rgba(255, 255, 255, 0.5))",
                  WebkitFilter:
                    "drop-shadow(0px 0px 2px rgba(255, 255, 255, 0.5))",
                },
              },
            }}
          >
            <Image
              maw={32}
              mx="auto"
              radius="md"
              src={item.icon}
              alt={item.name}
            />
          </ActionIcon>
        ))}
      </Flex>
    </Flex>
  );
};

export default SocialsFooter;
